import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import { Reac, useState, useEffect, useRef } from "react";
import { Button, PageHeader, Table, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { useNavigate, useLocation } from "react-router-dom";
import { Styled } from "../../pageStyled";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import EmptyState from "../../../Components/EmptyState/emptyState";
import {
  getRewinderRecords,
  searchRewinders,
  getFilteredRewinders
} from "../../../Services/machineServices";
import moment from "moment";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import {
  currency_List,lengthUnit,weightUnit 
  } from "../../../Utils/Constant/MeasurementUnitList.jsx";
  
const RewinderRecords = (props) => {
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const location = useLocation();
  const history = useNavigate();
  const [addToaster, setAddToaster] = useState(
    location.state?.action === "add"
  );
  const [tableParams, setTableParams] = useState({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10,
  });
  const paginationRef = useRef({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10
  });
  const [rewinderRecords, setRewinderRecords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [rendering, setRendering] = useState(false);
  const [totalRecords, setTotalRecords] = useState();
  const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

  const titleRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, table: 100 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        table: baseTop + titleHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, [rendering]);

  const columnsHead = useRef([
    {
      title: "Rewinder Code",
      dataIndex: "code",
      width: "8%",
      sorter: {
        compare: (a, b) => a.code - b.code,
      },
      fixed: "left",
      align: "left",
    },
    {
      title: "Rewinder Name",
      dataIndex: "name",
      width: "8%",
      fixed: "left",
    },
    {
      title: "GSM Range",
      dataIndex: "gsm_range",
      width: "7%",
    },
    {
      title: "Width Range",
      dataIndex: "width_range",
      width: "8%",
    },
    // {
    //   title: "Left Edge Trim",
    //   dataIndex: "left_edge_trim",
    //   width: "8%",
    // },
    // {
    //   title: "Right Edge Trim",
    //   dataIndex: "right_edge_trim",
    //   width: "8%",
    // },
    // {
    //   title: "Effective Max Deckle",
    //   dataIndex: "effective_deckle_length",
    //   width: "8%",
    // },
    // {
    //   title: "Max Loss %",
    //   dataIndex: "maximum_loss",
    //   width: "8%",
    // },
    {
      title: "Loading Stands",
      dataIndex: "loading_stands",
      width: "8%",
    },
    {
      title: "Supported Ply",
      dataIndex: "ply",
      width: "8%",
    },
    {
      title: "Cutters",
      dataIndex: "cutters",
      width: "6%",
    },
    {
      title: "Capacity",
      dataIndex: "capacity",
      width: "6%",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      width: "8%",
      // sorter: (a, b, sortOrder) => a.created_at.localeCompare(b.created_at),
      sorter: {
        compare: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      }
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "5%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Active"
                  ? "This rewinder can be used for deckle matching."
                  : record.status === "Disabled"
                  ? "This rewinder is disabled and cannot be used for used for deckle matching."
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "8%",
      align: "center",
      render: (text, record) => (
        <div className="actionBtn">
          {userDetails.roles.machine_records.edit && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit this rewinder"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => handleEdit(record.code)}>
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this rewinder"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleView(record.code)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ]);

  // useEffect(() => {
  //   setLoading(true);
  //   if(rendering && !appliedFilters.length && searchValue == "") {
  //     fetchRewinderRecords(paginationRef.current);
  //     setRendering(false);
  //   } else if(!appliedFilters.length && searchValue == "") {
  //     fetchRewinderRecords(paginationRef.current);
  //   }
  // }, [tableParams, rendering]);

  useEffect(() => {
    setLoading(true);
    if (appliedFilters.length) {
      fetchFilteredRewinders();
    } else if (!appliedFilters.length && searchValue !== "") {
      searchRewinders(searchValue, paginationRef.current)
        .then((response) => {
          setLoading(false);
          setEmptyStateLabel("search");
          const formattedRecords = response?.rewinders?.map((rewinder) => {
            const allWidths = Object.values(rewinder.gsm_wise_configs || {}).flat();

            let widthRange = "-";

            if (allWidths.length) {
              const minWidth = Math.min(...allWidths.map(w => w.min_deckle_width));
              const maxWidth = Math.max(...allWidths.map(w => w.max_deckle_width));

              // Get first available unit (since unit same across widths)
              const firstMachineCode = Object.keys(rewinder.units?.gsm_wise_configs || {})[0];
              const widthUnit =
                lengthUnit[
                  rewinder.units?.gsm_wise_configs?.[firstMachineCode]?.max_deckle_width
                ]?.displayName?.toUpperCase() || "";

              widthRange = `${minWidth} - ${maxWidth} ${widthUnit}`;
            }

            return {
              code: rewinder.code,
              name: rewinder.name,
              gsm_range: `${rewinder.minimum_gsm} - ${rewinder.maximum_gsm}`,
              width_range: widthRange,
              // width_range: `${rewinder.minimum_width} - ${rewinder.maximum_width} ${lengthUnit[rewinder.units.maximum_width]?.displayName.toUpperCase()}`,
              // left_edge_trim: rewinder.left_edge_trim + " " + lengthUnit[rewinder.units.left_edge_trim]?.displayName.toUpperCase(),
              // right_edge_trim: rewinder.right_edge_trim + " " + lengthUnit[rewinder.units.right_edge_trim]?.displayName.toUpperCase(),
              // effective_deckle_length: rewinder.effective_deckle_length + " " + lengthUnit[rewinder.units.effective_deckle_length]?.displayName.toUpperCase(),
              // maximum_loss: rewinder.maximum_loss.toFixed(3) + " %",
              cutters: rewinder.maximum_cutters,
              created_at: moment(rewinder.created_at).format("DD MMM YYYY"),
              status: rewinder.status === "active" ? "Active" : "Disabled",
              capacity: rewinder.capacity + " " + capitalize(weightUnit[rewinder.units.capacity]?.displayName) + ' / day',
              loading_stands : rewinder.loading_stands,
              ply : rewinder.ply ? rewinder.ply.join(", ") : '-',
            };
          });
          setRewinderRecords(formattedRecords);
          setTotalRecords(response.total_rewinders);
        })
        .catch((error) => 
          console.log("Error in searching rewinders:", error),
          setEmptyStateLabel("connectionAPIError")
        );
    } else {
      fetchRewinderRecords(paginationRef.current);
    }
  }, [appliedFilters, tableParams, searchValue, rendering]);

  useEffect(() => {
    let propsData = {};
    if(emptyStateLabel === "noData"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if(emptyStateLabel === "search"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if(emptyStateLabel === "filter"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  },[emptyStateLabel]);

  const refresh  = () => {
    setLoading(true);
    setRewinderRecords();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  };

  const fetchRewinderRecords = async (params) => {
    try {
      const records = await getRewinderRecords(params);
      if(!records?.rewinders?.length){
        setEmptyStateLabel("noData");
      }
      const formattedRecords = records?.rewinders?.map((rewinder) => {
        const allWidths = Object.values(rewinder.gsm_wise_configs || {}).flat();

        let widthRange = "-";

        if (allWidths.length) {
          const minWidth = Math.min(...allWidths.map(w => w.min_deckle_width));
          const maxWidth = Math.max(...allWidths.map(w => w.max_deckle_width));

          // Get first available unit (since unit same across widths)
          const firstMachineCode = Object.keys(rewinder.units?.gsm_wise_configs || {})[0];
          const widthUnit =
            lengthUnit[
              rewinder.units?.gsm_wise_configs?.[firstMachineCode]?.max_deckle_width
            ]?.displayName?.toUpperCase() || "";

          widthRange = `${minWidth} - ${maxWidth} ${widthUnit}`;
        }

        return {
          code: rewinder.code,
          name: rewinder.name,
          gsm_range: `${rewinder.minimum_gsm} - ${rewinder.maximum_gsm}`,
          width_range: widthRange,
          // width_range: `${rewinder.minimum_width} - ${rewinder.maximum_width} ${lengthUnit[rewinder.units.maximum_width]?.displayName.toUpperCase()}`,
          //     left_edge_trim: rewinder.left_edge_trim + " " + lengthUnit[rewinder.units.left_edge_trim].displayName.toUpperCase(),
          //     right_edge_trim: rewinder.right_edge_trim + " " + lengthUnit[rewinder.units.right_edge_trim].displayName.toUpperCase(),
          //     effective_deckle_length: rewinder.effective_deckle_length + " " + lengthUnit[rewinder.units.effective_deckle_length].displayName.toUpperCase(),
          // maximum_loss: rewinder.maximum_loss.toFixed(3) + " %",
          cutters: rewinder.maximum_cutters,
          created_at: moment(rewinder.created_at).format("DD MMM YYYY"),
          status: rewinder.status === "active" ? "Active" : "Disabled",
          capacity: rewinder.capacity + " " + capitalize(weightUnit[rewinder.units.capacity].displayName) + ' / day',
          loading_stands : rewinder.loading_stands,
          ply : rewinder.ply ? rewinder.ply.join(", ") : '-',
                };
      });
      setRewinderRecords(formattedRecords);
      setTotalRecords(records.total_rewinders);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("Error in fetching rewinder records", err);
      setLoading(false);
      setEmptyStateLabel("connectionAPIError");
    }
  };

  const searchMach = async (value = "") => {
    setRewinderRecords([]);
    setLoading(true);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
    setSearchValue(value);
    // if (value === "" || value === null) {
    //   setAppliedFilters([]);
    //   setFilterTags([]);
    //   fetchRewinderRecords(paginationRef.current);
    // } else {
    //   setClearSearch(false);
    //   searchRewinders(value, paginationRef.current)
    //     .then((response) => {
    //       setLoading(false);
    //       setEmptyStateLabel("search");
    //       const formattedRecords = response?.rewinders?.map((rewinder) => {
    //         return {
    //           code: rewinder.code,
    //           name: rewinder.name,
    //           gsm_range: `${rewinder.minimum_gsm} - ${rewinder.maximum_gsm}`,
    //           width_range: `${rewinder.minimum_width} - ${rewinder.maximum_width} ${lengthUnit[rewinder.units.maximum_width].displayName.toUpperCase()}`,
    //           left_edge_trim: rewinder.left_edge_trim + " " + lengthUnit[rewinder.units.left_edge_trim].displayName.toUpperCase(),
    //           right_edge_trim: rewinder.right_edge_trim + " " + lengthUnit[rewinder.units.right_edge_trim].displayName.toUpperCase(),
    //           effective_deckle_length: rewinder.effective_deckle_length + " " + lengthUnit[rewinder.units.effective_deckle_length].displayName.toUpperCase(),
    //           maximum_loss: rewinder.maximum_loss.toFixed(3) + " %",
    //           cutters: rewinder.maximum_cutters,
    //           created_at: moment(rewinder.created_at).format("DD MMM YYYY"),
    //           status: rewinder.status === "active" ? "Active" : "Disabled",
    //           capacity: rewinder.capacity + " " + capitalize(weightUnit[rewinder.units.capacity].displayName) + ' / day',
    //           loading_stands : rewinder.loading_stands,
    //           ply : rewinder.ply ? rewinder.ply.join(", ") : '-',
    //         };
    //       });
    //       setRewinderRecords(formattedRecords);
    //       setTotalRecords(response.total_rewinders);
    //     })
    //     .catch((error) => 
    //       console.log("Error in searching rewinders:", error),
    //       setEmptyStateLabel("connectionAPIError")
    //     );
    // }
  };

  const fetchFilteredRewinders = () => {
   
    getFilteredRewinders(paginationRef.current, appliedFilters,'',searchValue)
      .then((response) => {
        setLoading(false);
        setEmptyStateLabel("filter");
        const filteredList = response?.data?.rewinders?.map((rewinder) => {
          const allWidths = Object.values(rewinder.gsm_wise_configs || {}).flat();

            let widthRange = "-";

            if (allWidths.length) {
              const minWidth = Math.min(...allWidths.map(w => w.min_deckle_width));
              const maxWidth = Math.max(...allWidths.map(w => w.max_deckle_width));

              // Get first available unit (since unit same across widths)
              const firstMachineCode = Object.keys(rewinder.units?.gsm_wise_configs || {})[0];
              const widthUnit =
                lengthUnit[
                  rewinder.units?.gsm_wise_configs?.[firstMachineCode]?.max_deckle_width
                ]?.displayName?.toUpperCase() || "";

              widthRange = `${minWidth} - ${maxWidth} ${widthUnit}`;
            }
          return {
            code: rewinder.code,
              name: rewinder.name,
              gsm_range: `${rewinder.minimum_gsm} - ${rewinder.maximum_gsm}`,
               width_range: widthRange,
              // width_range: `${rewinder.minimum_width} - ${rewinder.maximum_width} ${lengthUnit[rewinder.units.maximum_width].displayName.toUpperCase()}`,
              // left_edge_trim: rewinder.left_edge_trim + " " + lengthUnit[rewinder.units.left_edge_trim].displayName.toUpperCase(),
              // right_edge_trim: rewinder.right_edge_trim + " " + lengthUnit[rewinder.units.right_edge_trim].displayName.toUpperCase(),
              // effective_deckle_length: rewinder.effective_deckle_length + " " + lengthUnit[rewinder.units.effective_deckle_length].displayName.toUpperCase(),
              // maximum_loss: rewinder.maximum_loss.toFixed(3) + " %",
              cutters: rewinder.maximum_cutters,
              created_at: moment(rewinder.created_at).format("DD MMM YYYY"),
              status: rewinder.status === "active" ? "Active" : "Disabled",
              capacity: rewinder.capacity + " " + capitalize(weightUnit[rewinder.units.capacity].displayName) + ' / day',
              loading_stands : rewinder.loading_stands,
              ply : rewinder.ply ? rewinder.ply.join(", ") : '-',
          };
        });
        setRewinderRecords(filteredList);
        setTotalRecords(response.data.total_rewinders);
      })
      .catch((error) => 
      console.log(error),
      setEmptyStateLabel("connectionAPIError"));
  };

  const applyfilter = (filter) => {
    setRewinderRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
        setCurrentPage(1);
       
        paginationRef.current = {
          sort_by: "created_at",
          sort_type: "descending",
          page: 1,
          size: 10
        }
        let temp = appliedFilters;
        let alreadySetFilter = false;
        for (let i = 0; i < temp.length; i++) {
          if (temp[i].type === filter.type) {
            temp[i] = filter;
            alreadySetFilter = true;
          }
        }
        const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
        setAppliedFilters(tempVar);
        setFilterTags(tempVar.map(formatFilters));
         setTableParams( (prevState) => ({
          sort_by: "created_at",
          sort_type: "descending",
          page: 1,
          size: 10
        }));
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "min_gsm":
        let minGsmOperand = "";
        let minGsmValue = "";
        if (item.operator === "in_range") {
          minGsmOperand = "between";
          minGsmValue = `${item.min_gsm_range} and ${item.max_gsm_range}`;
        } else if (item.operator === "equal_to") {
          minGsmOperand = "equals";
          minGsmValue = `${item.min_gsm}`;
        } else if (item.operator === "equal_to") {
          minGsmOperand = "equals";
          minGsmValue = `${item.min_gsm}`;
        } else if (item.operator === "less_than") {
          minGsmOperand = "less than";
          minGsmValue = `${item.min_gsm}`;
        } else {
          minGsmOperand = "greater than";
          minGsmValue = `${item.min_gsm}`;
        }
        return {
          type: item.type,
          formattedType: "Min.GSM",
          operand: minGsmOperand,
          value: minGsmValue,
        };
      case "max_gsm":
        let maxGsmOperand = "";
        let maxGsmValue = "";
        if (item.operator === "in_range") {
          maxGsmOperand = "between";
          maxGsmValue = `${item.max_gsm_start} and ${item.max_gsm_end}`;
        } else if (item.operator === "equal_to") {
          maxGsmOperand = "equals";
          maxGsmValue = `${item.max_gsm}`;
        } else if (item.operator === "less_than") {
          maxGsmOperand = "less than";
          maxGsmValue = `${item.max_gsm}`;
        } else {
          maxGsmOperand = "greater than";
          maxGsmValue = `${item.max_gsm}`;
        }
        return {
          type: item.type,
          formattedType: "Max.GSM",
          operand: maxGsmOperand,
          value: maxGsmValue,
        };
      case "min_deckle_width":
        let minDeckOperand = "";
        let minDeckValue = "";
        if (item.operator === "in_range") {
          minDeckOperand = "between";
          minDeckValue = `${item.min_deckle_width} and ${item.max_deckle_width}`;
        } else if (item.operator === "equal_to") {
          minDeckOperand = "equals";
          minDeckValue = `${item.deckle_width}`;
        } else if (item.operator === "less_than") {
          minDeckOperand = "less than";
          minDeckValue = `${item.deckle_width}`;
        } else {
          minDeckOperand = "greater than";
          minDeckValue = `${item.deckle_width}`;
        }
        return {
          type: item.type,
          formattedType: "Min. Deckle Width",
          operand: minDeckOperand,
          value: minDeckValue,
        };
      case "max_deckle_width":
        let maxDeckOperand = "";
        let maxDeckValue = "";
        if (item.operator === "in_range") {
          maxDeckOperand = "between";
          maxDeckValue = `${item.min_deckle_width} and ${item.max_deckle_width}`;
        } else if (item.operator === "equal_to") {
          maxDeckOperand = "equals";
          maxDeckValue = `${item.deckle_width}`;
        } else if (item.operator === "less_than") {
          maxDeckOperand = "less than";
          maxDeckValue = `${item.deckle_width}`;
        } else {
          maxDeckOperand = "greater than";
          maxDeckValue = `${item.deckle_width}`;
        }
        return {
          type: item.type,
          formattedType: "Max. Deckle Width",
          operand: maxDeckOperand,
          value: maxDeckValue,
        };
      case "maximum_loss":
        let maxWasteOperand = "";
        let maxWasteValue = "";
        if (item.operator === "in_range") {
          maxWasteOperand = "between";
          maxWasteValue = `${item.min_maximum_loss} and ${item.max_maximum_loss}`;
        } else if (item.operator === "equal_to") {
          maxWasteOperand = "equals";
          maxWasteValue = `${item.maximum_loss}`;
        } else if (item.operator === "less_than") {
          maxWasteOperand = "less than";
          maxWasteValue = `${item.maximum_loss}`;
        } else {
          maxWasteOperand = "greater than";
          maxWasteValue = `${item.maximum_loss}`;
        }
        return {
          type: item.type,
          formattedType: "Maximum Loss",
          operand: maxWasteOperand,
          value: maxWasteValue,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "status":
        const formattedStatus =
          item.status === "both"
            ? `Active/Disabled`
            : item.status === "active"
            ? `Active`
            : `Disabled`;
        return {
          type: item.type,
          formattedType: "Status",
          operand: "-",
          value: formattedStatus,
        };
        case "capacity":
        let capacityOperand = "";
        let capacityValue = "";
        if (item.operator === "in_range") {
          capacityOperand = "between";
          capacityValue = `${item.min_capacity} and ${item.max_capacity}`;
        } else if (item.operator === "equal_to") {
          capacityOperand = "equals";
          capacityValue = `${item.capacity}`;
        } else if (item.operator === "equal_to") {
          capacityOperand = "equals";
          capacityValue = `${item.capacity}`;
        } else if (item.operator === "less_than") {
          capacityOperand = "less than";
          capacityValue = `${item.capacity}`;
        } else {
          capacityOperand = "greater than";
          capacityValue = `${item.capacity}`;
        }
        return {
          type: item.type,
          formattedType: "Capacity",
          operand: capacityOperand,
          value: capacityValue,
        };
      
    }
  };

  const removeFilter = (filter) => {
    setRewinderRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
        const filterList = appliedFilters.filter((item) => {
          return item.type !== filter.type;
        });
        const formattedFilterList = filterTags.filter((item) => {
          return item.type !== filter.type;
        });
        setFilterTags(formattedFilterList);
        setAppliedFilters(filterList);
        // setRendering(true);
        // setSearchValue("");
        // setClearSearch(true);
        setLoading(true);
        setCurrentPage(1);
        setTableParams( (prevState) => ({
          sort_by: "created_at",
          sort_type: "descending",
          page: 1,
          size: 10
        }));
        paginationRef.current = {
          sort_by: "created_at",
          sort_type: "descending",
          page: 1,
          size: 10
        }
  };
  
  const routeChange = () => {
    history("../add-new-rewinder",{
      state: {
        action : 'add'
      }
    });
  };

  const exportHandler = () => {
    const currentDate = new Date();
    const today = (currentDate.getDate() + "/" + currentDate.toLocaleString("default", { month: "long" }) + "/" +  currentDate.getFullYear());
    let fileName = "Rewinder_Records_Kiaznn_"+today;
    if (appliedFilters.length) {
      history("../rewinder-records/export-rewinder", {
        state: {
          body: {
            appliedFilters: appliedFilters,
            page: "rewinder records",
            type: "Filter",
            searchValue: searchValue

          },
          rootPage: "../rewinder-records",
          fileName: fileName,
        },
      });
    } else if(!clearSearch && searchValue){
      let params = {
        sort_by: "created_at",
        sort_type: "descending",
      }
      history("../rewinder-records/export-rewinder", {
          state: {
            body: {
              searchValue: searchValue,
              params: params,
              page: "rewinder records",
              type: "Search"
            },
            rootPage: "../rewinder-records",
            fileName: fileName,
          },
      });
    } else {
      history("../rewinder-records/export-rewinder", {
        state: {
          body: {
            page: "rewinder records",
            type: "All Data"
          },
          rootPage: "../rewinder-records",
          fileName: fileName,
        },
      });
    }
  };

  function onChange(pagination, filters, sorter, extra) {
    setRewinderRecords([]);
    setLoading(true);
    columnsHead.current?.map((item) => {
      if(item.dataIndex !== sorter?.field){
        item["sortOrder"] = null;
      } 
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
    if (
      sorter.field &&
      (paginationRef.current.sort_type !== tempSort )
    ) {
      setClearSearch(true);
      setCurrentPage(1);
      setTableParams({
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      };
    } else {
      setClearSearch(true);
      setCurrentPage(pagination.current);
      setTableParams({
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      };
    }
  }

  const handleEdit = (code) => {
    history("../edit-rewinder",{
      state: {
        action : 'edit',
        code : code
      }
    });
  };

  const handleView = (code) => {
    history("../view-rewinder",{
      state: {
        action : 'view',
        code : code
      }
    });
  };

  return (
    <RightLayoutContainer id="right-layout-container">
      <style dangerouslySetInnerHTML={{
        __html: `
        .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
          overflow: visible !important;
        }
        .ant-table-sticky-holder {
          z-index: 101 !important;
        }
        .tableDataFormat table colgroup col {
          min-width: 100px !important;
        }
      `}} />
      <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff", paddingBottom: "10px" }}>
        <PageHeader
          ghost={false}
          title="Rewinder Records"
          extra={
            userDetails?.roles?.machine_records.edit && [
              <Button key="1" className="themeBtn" onClick={routeChange}>
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Add New Rewinder
              </Button>,
            ]
          }
        ></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <SearchContainer
            placeholder={"Search Rewinder Code or Rewinder Name"}
            fetchOrder={searchMach}
            exportRole={rewinderRecords?.length ? true : false}
            exportTrigger={exportHandler}
            clearSearch={clearSearch}
            setClearSearch={setClearSearch}
            searchedValue={searchValue}
            filterOptions={[
              {
                key: 0,
                label: "Filter by Min GSM",
                value: "min_gsm",
                type: "inputSelect",
              },
              {
                key: 1,
                label: "Filter by Max GSM",
                value: "max_gsm",
                type: "inputSelect",
              },
              {
                key: 2,
                label: "Filter by Min Deckle Width",
                value: "min_deckle_width",
                type: "inputSelect",
                unitType : "length"
              },
              {
                key: 3,
                label: "Filter by Max Deckle Width",
                value: "max_deckle_width",
                type: "inputSelect",
                unitType : "length"
              },
              {
                key: 4,
                label: "Filter by Capacity",
                value: "capacity",
                type: "inputSelect",
                unitType:"weight"
              },
              {
                key: 5,
                label: "Filter by Maximum loss",
                value: "maximum_loss",
                type: "inputSelect",
              },
              {
                key: 6,
                label: "Filter by Created date",
                value: "created_date",
                type: "date",
              },
              {
                key: 7,
                label: "Filter by Status",
                value: "status",
                type: "multiSelect",
              },
            ]}
            applyFilter={applyfilter}
          />
          {filterTags.map((filter) => (
            <span className="filter-tags">
              <Iconmoon icon="filter" size={13} color="#a8a8a8" />
              &nbsp;
              <span>{filter.formattedType}</span>
              &nbsp;
              <span>{filter.operand}</span>
              &nbsp;
              <span>{filter.value}</span>
              <span>
                {" "}
                <button
                  onClick={() => {
                    removeFilter(filter);
                  }}
                >
                  {" "}
                  <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                </button>
              </span>
            </span>
          ))}
          {loading ? (
                    <TableShimmer
                      header = {columnsHead.current}
                      scroll={{ x: window.screen.width < 1500 && 1460 }}
                    />
                  ):(
                    rewinderRecords?.length ? (
                      <Table
                        columns={columnsHead.current}
                        dataSource={rewinderRecords}
                        onChange={onChange}
                        pagination={{
                          pageSizeOptions: [10, 20, 50, 100],
                          showSizeChanger: true,
                          current: currentPage,
                          total: totalRecords,
                          showTitle: false,
                          pageSize: paginationRef.current.size,
                          showTotal: (total, range) =>
                            `Showing ${range[0]}-${range[1]} of ${total} results`,
                        }}
                        scroll={{ x: "max-content" }}
                        sticky={{
                          offsetHeader: stickyOffsets.table,
                          getContainer: () => {
                            let node = document.getElementById('right-layout-container');
                            while (node && node !== document.body) {
                              const style = window.getComputedStyle(node);
                              if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                              node = node.parentNode;
                            }
                            return window;
                          }
                        }}
                      />
                      ) : (
                        <EmptyState
                            img= {emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData : 
                            emptyStateLabel === "search" ? emptyState_Search : 
                            emptyState_ConnectionAPIError}
                            heading= {emptyStatePropsData.heading}
                            subHeading= {emptyStatePropsData.subHeading}
                            label={emptyStatePropsData.label}
                            refresh={refresh}
                            />
                      )
                  )}
        </div>
      </TableLayoutData>
    </RightLayoutContainer>
  );
};

export default RewinderRecords;
